import { useState } from "react";

const BMC_LOGO = "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/bmc_logo.png";

const BmcHeader = () => {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="bmc-header">
      {logoFailed ? (
        <div className="bmc-header-logo-fallback">BMC</div>
      ) : (
        <img
          src={BMC_LOGO}
          alt="BMC"
          className="bmc-header-logo"
          onError={() => setLogoFailed(true)}
        />
      )}
      <span className="bmc-header-title">Paying BMC</span>
    </div>
  );
};

export default BmcHeader;
